import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BeneficiaryShareChanges } from '../beneficiary-submission-share-change/beneficiary-share-change-type';
import { BeneficiaryShareChangeTypeEnum } from '../beneficiary-submission-share-change/beneficiary-share-change-type.enum';
import { CommonModule } from '@angular/common';
import { BeneficiarySubmissionShareChangeComponent } from '../beneficiary-submission-share-change/beneficiary-submission-share-change.component';

@Component({
  selector: 'app-beneficiary-submission-share-change-list',
  standalone: true,
  imports: [CommonModule, BeneficiarySubmissionShareChangeComponent],
  templateUrl: './beneficiary-submission-share-change-list.component.html',
  styleUrls: ['./beneficiary-submission-share-change-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class BeneficiarySubmissionShareChangeListComponent implements OnChanges {
  @Input() beneficiaryChanges!: BeneficiaryShareChanges;
  @Input() alternateBeneficiaries: boolean = false;

  public hasChanges = false;

  public noChangesText: string = '';

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.beneficiaryChanges || changes.alternateBeneficiaries) {
      this.hasChanges = this.beneficiaryChanges.new.some(c => c.changeType !== BeneficiaryShareChangeTypeEnum.Neutral);
      const noAlternateBeneficiaries =
        this.alternateBeneficiaries &&
        this.beneficiaryChanges.old.every(c => c.changeType === BeneficiaryShareChangeTypeEnum.Removed);

      if (!this.hasChanges) {
        this.noChangesText = noAlternateBeneficiaries ? $localize`No alternate beneficiaries` : $localize`No changes`;
      }
    }
  }
}
